module.exports = __webpack_public_path__ + "static/media/yui-hatano-icon.aa60b248.jpg";